<template>
    <div class="component power-hours-day-graph">
        <div class="row">
            <div class="col-12">
                <el-card class="box-card mt-50" v-loading="loading">
                    <div slot="header" class="text-left">
                        <h4 class="title inline">Store ranking</h4>
                        <el-radio-group v-model="$store.state.graphFilter.powerhoursSwitch" @change="sortRankData()" size="medium" class="vertical-center switch-right fr ml-5-howrly">
                            <el-radio-button label="Prod"></el-radio-button>
                            <el-radio-button label="Index"></el-radio-button>
                            <el-radio-button label="Score"></el-radio-button>
                        </el-radio-group>
                        <el-select v-model="numRecords" class="fr" style="width: 120px;">
                            <el-option :value="data.length" label="All"></el-option>
                            <el-option :value=10 label="Top 5"></el-option>
                            <el-option :value=20 label="Top 10"></el-option>
                            <el-option :value=30 label="Top 15"></el-option>
                        </el-select>
                    </div>
                    <el-table
                        :data="getData"
                        style="width: 100%"
                        @row-click="handleRowClick"
                        :default-sort = "{prop: 'Rank', order: 'Ascending'}"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyling"
                        :header-cell-style="columnStyling">
                        >
                        <el-table-column prop="Rank" label="Rank">
                            <template slot-scope="scope">
                                {{scope.row.Rank}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="store_id" label="Store">
                            <template slot-scope="scope">
                                {{$store.state.general.stores.find(x => x.store_id === scope.row.store_id).store_name}}
                            </template>
                        </el-table-column>
                        <el-table-column  v-for="col in headers"
                                          :key="col.prop"
                                          :prop="col.prop"
                                          :label="col.prop | formatVariableName"
                                          :sortable=false
                                          :formatter="formatter">
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getHeadersWithAccessToken, getTableHeaders } from '../../functions'

export default {
    data () {
        return {
            loaded: false,
            loading: true,
            data: [],
            columns: [],
            numRecords: 10
        }
    },
    methods: {
        handleRowClick (row) {
            // let store = this.$store.state.general.stores.find(x => x.store_name === row.store_name).store_id
            this.$store.commit('graphFilter/SET_POWER_HOURS_SELECTED_STORE', row.store_id)
            this.$emit('rowClicked', { 'store': [row.store_id] })
        },
        getTableData (stores) {
            this.loading = true
            let params = { 'format': 'aod', 'store_id': stores }
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/performance/powerhours/toplist', params, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.data = this.sortRankData(response.data.data)
                    // for (let item of this.data) {
                    //     if (item['power_hours_score'] === 0) {
                    //         delete item['power_hours_score']
                    //     }
                    // }
                    this.columns = getTableHeaders(response.data.columns)

                    // Add rank and swap for ordering
                    let headersCopy = JSON.parse(JSON.stringify(this.columns))
                    this.columns = []
                    for (let i = 0; i < headersCopy.length; i++) {
                        this.columns[i] = headersCopy[i]
                    }
                    this.loaded = true
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                })
        },
        sortRankData (data = this.data) {
            let newData = []
            // Sort the list
            if (this.$store.state.graphFilter.powerhoursSwitch === 'Index') {
                newData = data.sort((a, b) => (a['day_index'] < b['day_index']) ? 1 : -1)
            } else if (this.$store.state.graphFilter.powerhoursSwitch === 'Prod') {
                newData = data.sort((a, b) => (a['productivity'] < b['productivity']) ? 1 : -1)
            } else {
                newData = data.sort((a, b) => (a['power_hours_score'] < b['power_hours_score']) ? 1 : -1)
            }
            // Set the rank
            for (let i = 0; i < newData.length; i++) {
                newData[i]['Rank'] = parseInt(i + 1)
            }
            return newData
        },
        cellStyling (param) {
            const { column, row } = param
            const mapping = { 'Index': 'day_index', 'Prod': 'productivity', 'Score': 'power_hours_score' }
            if (column.property === 'Rank' && row[column.property] !== null) {
                if (this.data.length === 1) {
                    return { }
                } else if (row['Rank'] > (this.getData.length / 2)) {
                    return { color: '#de1738', fontWeight: '800' }
                } else {
                    return { color: '#2e8b57', fontWeight: '800' }
                }
            }
            if (column.property === mapping[this.$store.state.graphFilter.powerhoursSwitch] && row[column.property] !== null) {
                return { fontWeight: '800' }
            }
        },
        columnStyling (param) {
            const { column } = param
            const mapping = { 'Index': 'day_index', 'Prod': 'productivity', 'Score': 'power_hours_score' }
            if (column.property === mapping[this.$store.state.graphFilter.powerhoursSwitch]) {
                return { fontWeight: '800', color: '#606266' }
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            let store = row.store_id
            if (store === this.$store.state.graphFilter.powerhoursSelectedStore) {
                return 'highlight-row'
            }
        },
        formatter (row, column) {
            if (row[column.property] !== undefined) {
                if (column.property === 'Rate' || column.property === 'Costs' || column.property.includes('prod')) {
                    return '€' + row[column.property].toLocaleString('en-EN')
                } else if (column.property.includes('perc')) {
                    return row[column.property] + '%'
                } else {
                    return row[column.property].toLocaleString('en-EN')
                }
            }
        }
    },
    computed: {
        getData () {
            if (this.loaded === false) {
                return []
            } else {
                if (this.data.length > (this.numRecords - 1)) {
                    let newData = []
                    let data = this.sortRankData()
                    for (let idx = 0; idx < (this.numRecords / 2); idx++) {
                        if (data[idx] !== undefined) {
                            newData.push(data[idx])
                        }
                    }
                    for (let idx = data.length - 1; idx >= data.length - (this.numRecords / 2); idx--) {
                        if (data[idx] !== undefined) {
                            newData.push(data[idx])
                        }
                    }
                    return newData
                } else {
                    return this.data
                }
            }
        },
        headers () {
            if (this.loaded === true) {
                let columnsCopy = JSON.parse(JSON.stringify(this.columns))
                let idx = columnsCopy.indexOf(columnsCopy.find(x => x.prop === 'store_id'))
                columnsCopy.splice(idx, 1)
                return columnsCopy
            } else {
                return []
            }
        }
    },
    created () {
        // this.getTableData()
    }
}
</script>
